"use client";

/**
 * In-shell navigation — the zero-network tab switch. Each app is one
 * catch-all route (/trip/[id]/[[...tab]], /finance/[[...page]]) rendering a
 * client component that switches on the pathname, so "navigating" between
 * tabs is a plain history.pushState: Next syncs usePathname/useSearchParams
 * from it (documented native-History-API interop) and NOTHING is fetched —
 * no RSC payload, no prefetch, no router cache. The app touches the network
 * only on Refresh/Sync/Update.
 *
 * Use ONLY for URLs served by the SAME catch-all shell. Cross-shell jumps
 * (launcher ↔ trip ↔ finance ↔ /trips) must be real navigations — plain
 * <a href> — which the SW serves from the precache, also without network.
 */
export function navigateInShell(href: string, opts?: { replace?: boolean }) {
  if (opts?.replace) {
    window.history.replaceState(null, "", href);
    return;
  }
  window.history.pushState(null, "", href);
  // The router scrolls to top on real navigations; pushState doesn't.
  window.scrollTo(0, 0);
}

/** Click handler for an in-shell <a> — keeps native semantics (middle-click,
 * cmd-click, copy link) while plain clicks stay in the shell. */
export function shellLinkClick(e: React.MouseEvent<HTMLAnchorElement>) {
  if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  e.preventDefault();
  navigateInShell(e.currentTarget.getAttribute("href") ?? "/");
}
